export const getMonthlyPriceReduction = (duration: number, paymentInAdvance?: number): number => {
	if (paymentInAdvance) {
		return paymentInAdvance / Number(duration);
	}
	return 0;
};
